export default __webpack_public_path__ + "static/media/img1.305152f4.jpg";